import PropTypes from "prop-types";
import Cookies from "js-cookie";
import React from 'react';
import { Link } from 'react-router-dom';

import './cookie-container-style.css';

class CookieContainer extends React.Component {
	constructor(props) {
	    super(props);	
	    this.state = {
		  visible: false,
		}
	}

	componentDidMount(){
		const { cookieName } = this.props;
		 // if cookie undefined or debug
		 if (Cookies.get(cookieName) === undefined) {
			this.setState({ visible: true });
		  }

	}

	  accept = () => {
	    const {
	      cookieName,
	      cookieValue,
	      expires,
	      extraCookieOptions
	    } = this.props;
	
	    Cookies.set(cookieName, cookieValue, { expires: expires, ...extraCookieOptions });
	
		this.setState({ visible: false });
	  }

	  /**
	   * Set a persistent decline cookie
	   */
	  decline() {
	    // const {
	    //   cookieName,
	    //   declineCookieValue,
	    //   expires,
	    //   extraCookieOptions,
	    //   setDeclineCookie
	    // } = this.props;
	
	    // if (setDeclineCookie) {
	    //   Cookies.set(cookieName, declineCookieValue, { expires: expires, ...extraCookieOptions });
	    // }
	
		this.setState({ visible: false });
	  }
	

	render (){
		if (!this.state.visible) {
			return null;
		  }
		return (
			<div className="consent-container">
				<div className="consent-header">
				<p>Your Privacy</p>
				<button onClick={this.decline.bind(this)}>X</button>
				</div>
				<div className="consent-body">
				<p className="consent-body_p">This site uses cookies to  improve your browser experience, perform analytics and research and conduct advertising. Clicking Accept all Cookies indicates
							you agree to the use of cookies on your device, which will give you best possible Browsing experience. You can manually edit your cookie settings by going
							to the cookie settings. You can find our privacy policy <Link to="/marketing/privacy">here</Link>.</p>
				<button onClick={this.accept.bind(this)} >Accept</button>
				</div>
			</div>
		);
	}
}
CookieContainer.propTypes = {
	cookieName: PropTypes.string,
	cookieValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
	declineCookieValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
	setDeclineCookie: PropTypes.bool,
	expires: PropTypes.number,
	extraCookieOptions: PropTypes.object,
  };

CookieContainer.defaultProps = {
	cookieName: "CookieConsent",
	cookieValue: true,
	declineCookieValue: false,
	setDeclineCookie: true,
	expires: 365,
	extraCookieOptions: {},
}

export default CookieContainer;